module.exports = __webpack_public_path__ + "static/img/14.d7b7920.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/articleProject/images/qlxj/14.png
// module id = KUPU
// module chunks = 5